export default __webpack_public_path__ + "static/cms-1-253366a80c50f0ef05516a5153cb1fd4.png";